import { Navigate, Route, Routes } from "react-router-dom";
import { ReceivePage } from "./pages/ReceivePage";

/** Recipient SPA only. Admin lives on Streamlit (st.internal.tr-com.net). */
export function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/r/" replace />} />
      <Route path="/r/:token" element={<ReceivePage />} />
      <Route
        path="*"
        element={
          <div className="shell receive-shell">
            <div className="panel receive-panel">
              <header className="receive-brand">
                <img
                  className="receive-logo"
                  src="/TR-COM.png"
                  alt="TR-COM"
                  width={72}
                  height={72}
                />
                <div>
                  <p className="receive-brand-name">TR-COM</p>
                  <h1>ファイル受け取り</h1>
                </div>
              </header>
              <p className="muted">
                メールに記載の受け取り URL（<code>/r/…</code>）を開いてください。
              </p>
            </div>
          </div>
        }
      />
    </Routes>
  );
}
